import React from "react";
import { Row, Col } from 'react-bootstrap'
import Carousel from 'nuka-carousel';

class Event extends React.Component {
	
	render() {
                var settings = {
                        dots: true,
                        infinite: true,
                        speed:1000,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        slidesPerRow:1,
                        vertical:{},
                        autoplay:true
                      };
		return (



        <div className="Event">
        
        <div className="container">

     <Carousel wrapAround
      
      renderCenterLeftControls={({ previousSlide }) => (
        <button onClick={previousSlide}><i class="fa fa-angle-left"></i></button>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <button onClick={nextSlide}><i class="fa fa-angle-right"></i>

        </button>
      )}>
     <div className="newlook">
             <h3 className="event-name newlook-caption"> Event</h3>
             <p> Egypt Fashion Festival 2018</p>
             <p class="event-caption-date">15th - 19th September 2018 </p>
     <img src={require("../../img/Home/event.png")}/>
     </div>
     <div className="newlook">
             <h3 className="event-name newlook-caption"> Event</h3>
             <p> Egypt Fashion Festival 2018</p>
             <p class="event-caption-date">15th - 19th September 2018 </p>
     <img src={require("../../img/Home/event.png")}/>
     </div>
     

      </Carousel>   

    

      </div>
        </div>

       );
    }
  }
  
  export default Event;
  


// WEBPACK FOOTER //
// ./src/Components/Event/Event.jsx